/**
 * exportCsv — download an array of objects as a CSV file.
 *
 * columns: [{ key: 'Operator_Id', label: 'ID' }, ...]
 * Values are quoted safely; a UTF-8 BOM is prepended so Excel opens it cleanly.
 */
export function exportCsv(filename, columns, rows) {
  const escape = (v) => {
    const s = v == null ? '' : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const header = columns.map((c) => escape(c.label)).join(',');
  const lines = rows.map((row) => columns.map((c) => escape(row[c.key])).join(','));
  const csv = '\uFEFF' + [header, ...lines].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/** Today as YYYY-MM-DD for filenames. */
export function dateStamp() {
  return new Date().toISOString().slice(0, 10);
}
